<template>
  <div class="my-filter-date-input">
    <vxe-input type="date" size="mini" v-model="option.data.start" @input="changeOptionEvent1"></vxe-input>
    -
    <vxe-input type="date" size="mini" v-model="option.data.end" @input="changeOptionEvent2"></vxe-input>
    <!-- <vxe-input
      type="text"
      size="mini"
      v-model="option.data"
      placeholder="支持回车筛选"
      @keyup="keyupEvent"
      @input="changeOptionEvent"
    ></vxe-input> -->
  </div>
</template>

<script>
export default {
  name: 'FilterDate',
  props: {
    params: Object
  },
  data() {
    return {
      column: null,
      option: null
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      const { column } = this.params
      let option = column.filters[0]
      // if (!option.data1) {
      //   option['data1'] = ''
      // }
      // if (!option.data2) {
      //   option['data2'] = ''
      // }
      // console.log(option)
      this.column = column
      this.option = option
    },
    changeOptionEvent() {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      $panel.changeOption(null, checked, option)
    },
    changeOptionEvent1() {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data.start || !!option.data.end
      $panel.changeOption(null, checked, option)
    },
    changeOptionEvent2() {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data.start || !!option.data.end
      $panel.changeOption(null, checked, option)
    },
    keyupEvent({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        $panel.confirmFilter()
      }
    }
  }
}
</script>

<style scoped>
.my-filter-date-input {
  padding: 0px;
  display: flex;
  justify-content: flex-start;
}
.my-filter-date-input .vxe-input {
  width: 100px;
}
</style>
